import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";

const ResponsiveDataComponent = ({ data }) => (
  <div className="mobile-data">
    {data.map((d, i) => (
      <Row key={i}>
        <Col xs={6} style={{ textAlign: "right" }}>
          <strong>{d.key}</strong>
        </Col>
        <Col xs={6}>{d.label}</Col>
      </Row>
    ))}
  </div>
);

ResponsiveDataComponent.propTypes = {
  data: PropTypes.array
};
export default ResponsiveDataComponent;
